<template>
	<div>
		<b-card no-body class="p-1">
			<div class="mb-2">
				<!-- Paginator -->
				<div class="mx-2 mb-2">
					<b-row>
						<b-col
							cols="12"
							sm="6"
							class="d-flex align-items-center justify-content-center justify-content-sm-start pl-0"
						>
							<span class="text-muted">
								Mostrando {{ start_page ? start_page : 0 }} a {{ to_page ? to_page : 0 }} de
								{{ total_data }} registros
							</span>
						</b-col>
						<!-- Pagination -->
						<b-col
							cols="12"
							sm="6"
							class="d-flex align-items-center justify-content-center justify-content-sm-end"
						>
							<b-pagination
								v-model="current_page"
								:total-rows="total_data"
								:per-page="perpage"
								first-number
								last-number
								class="mb-0 mt-1 mt-sm-0"
								prev-class="prev-item"
								next-class="next-item"
							>
								<template #prev-text>
									<feather-icon icon="ChevronLeftIcon" size="18" />
								</template>
								<template #next-text>
									<feather-icon icon="ChevronRightIcon" size="18" />
								</template>
							</b-pagination>
						</b-col>
					</b-row>
				</div>

				<b-row>
					<b-col cols="12" xl="4" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
						<label>Mostrar</label>
						<v-select
							v-model="perpage"
							:options="perPageOptions"
							:clearable="false"
							class="per-page-selector d-inline-block mx-50"
						/>
						<label class="mr-2">registros</label>
						<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refreshTable" />
					</b-col>

					<!-- Search -->
					<b-col cols="12" xl="8" class="mt-1">
						<div class="container-btns-page-specimens d-flex justify-content-end">
							<div class="d-flex">
								<b-form-input
									v-model="search_input"
									class="d-inline-block mr-1"
									placeholder="Buscar unidad de medida..."
									debounce="500"
									@keyup.enter="$refs['table-Weight'].refresh()"
								/>
							</div>
						</div>
					</b-col>
				</b-row>
			</div>

			<div class="table-responsive">
				<b-table
					:items="myProvider"
					:fields="fields"
					sticky-header="40vh"
					primary-key="id"
					:current-page="current_page"
					:per-page="perpage"
					responsive
					small
					show-empty
					ref="table-Weight"
				>
					<template #table-busy>
						<div class="text-center text-primary my-2">
							<b-spinner class="align-middle"></b-spinner>
							<strong>Cargando...</strong>
						</div>
					</template>
					<template #cell(id)="data">
						<div class="d-flex d-code">
							<span>{{ data.index + 1 }}</span>
						</div>
					</template>

					<template #cell(description)="data">
						<div class="d-flex d-code">
							<span>{{ data.item.description }}</span>
						</div>
					</template>
					<template #cell(name)="data">
						<div class="d-flex d-code">
							<span>{{ data.item.name }}</span>
						</div>
					</template>
					<template #cell(presentations)="data">
						<div class="d-flex flex-column align-items-center justify-content-center">
							<span v-for="datas in data.item.presentations" style="margin-top: 3px">
								<feather-icon v-if="datas.presentation" icon="ChevronsRightIcon" class="text-danger" />
								{{ datas.value }} - {{ datas.presentation ? datas.presentation : "" }}
							</span>
						</div>
					</template>
					<template #cell(created_at)="data">
						<div class="d-flex d-code created">
							<span>{{ data.item.created_by }}</span>
							<span>{{ data.item.created_at | myGlobalDay }}</span>
						</div>
					</template>
					<template #cell(actions)="data">
						<div class="d-flex d-code">
							<b-button @click="openEditModal(data.item)" variant="warning" class="btn-icon ml-1 btn-sm">
								<feather-icon icon="EditIcon" />
							</b-button>

							<b-button
								@click="openModalDetail(data.item)"
								variant="outline-primary"
								class="btn-icon ml-1 btn-sm"
							>
								<feather-icon icon="ListIcon" />
							</b-button>
							<b-button
								@click="deleteWeight(data.item.id, data.item.name)"
								variant="danger"
								class="btn-icon ml-1 btn-sm"
							>
								<feather-icon icon="Trash2Icon" />
							</b-button>
						</div>
					</template>
				</b-table>
			</div>
		</b-card>

		<WeightUnitModal
			v-if="openModalWeight"
			@close="openModalWeight = false"
			@registered="reset(), (openModalWeight = false)"
			:info="form"
			:type="`generic`"
		/>
		<DetailsUnitModal
			v-if="openModalDetails"
			@close="openModalDetails = false"
			:idUnit="idUnit"
			@registered="reset()"
		/>
	</div>
</template>

<script>
import Fields from "@/views/brain/administrative/views/weight-units/data/fields-data.js"
import ServiceWeight from "@/views/brain/administrative/views/weight-units/services/weight.service.js"
import WeightUnitModal from "@/views/brain/administrative/views/weight-units/components/WeightUnitModal.vue"
import DetailsUnitModal from "@/views/brain/administrative/views/weight-units/components/DetailsUnitModal.vue"
export default {
	components: {
		WeightUnitModal,
		DetailsUnitModal,
	},
	data() {
		return {
			start_page: 0,
			end_page: 0,
			total_data: 0,
			perpage: 100,
			next_page: "",
			current_page: 1,
			to_page: 0,
			perPageOptions: [10, 25, 50, 100],
			fields: Fields,
			search_input: "",
			openModalWeight: false,
			openModalDetails: false,
			idUnit: null,
			form: {
				id: null,
				name: null,
				description: null,
			},
		}
	},
	methods: {
		async myProvider(ctx) {
			this.isPreloading()
			const params = {
				search: this.search_input,
				page: ctx.currentPage,
				perpage: ctx.perPage,
			}
			try {
				const { data } = await ServiceWeight.getWeight(params)
				this.start_page = data.from
				this.to_page = data.to
				this.total_data = data.total
				this.current_page = data.current_page
				return data.data
			} catch (error) {
				console.log(error)
				return []
			} finally {
				this.isPreloading(false)
			}
		},

		async deleteWeight(id, name) {
			const confirm = await this.showConfirmSwal({
				text: `Eliminar la presentacion ${name}`,
			})
			if (!confirm.isConfirmed) return
			this.isPreloading()
			try {
				const deleted = await ServiceWeight.deleteWeight(id)
				this.showSuccessToast(deleted.message)
				this.reset()
			} catch (error) {
				this.showErrorSwal(s, error.response?.data)
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},

		openModalDetail(item) {
			this.idUnit = item
			this.openModalDetails = !this.openModalDetails
		},
		refreshTable() {
			this.$refs["table-Weight"].refresh()
		},
		createWeight() {
			this.form.id = null
			this.form.name = null
			this.form.description = null
			this.openModalWeight = true
		},
		openEditModal(data) {
			this.form.id = data.id
			this.form.name = data.name
			this.form.description = data.description
			this.openModalWeight = true
		},
		reset() {
			this.$refs["table-Weight"].refresh()
		},
	},
}
</script>

<style scoped>
.d-code {
	width: 100%;
	justify-content: center;
	align-items: center;
	padding: 1rem;
}
.created {
	flex-direction: column;
	gap: 0.5rem;
}
</style>
